import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  Alert,
  AlertTitle,
} from '@mui/material';
import {
  Dashboard,
  People,
  Home,
  Analytics,
  TrendingUp,
} from '@mui/icons-material';
import { EmployeeLayout } from '@/components/Layout';
import { SystemMetricsCards } from '@/components/admin';
import { useAuth } from '@/contexts/AuthContext';

const EmployeeDashboard: React.FC = () => {
  const { userProfile } = useAuth();

  const quickActions = [
    {
      title: 'User Management',
      description: 'Manage hosts and guests, view user activity',
      icon: <People />,
      href: '/admin/users',
      color: 'primary' as const,
    },
    {
      title: 'Listing Moderation',
      description: 'Review and moderate property listings',
      icon: <Home />,
      href: '/admin/listings',
      color: 'secondary' as const,
    },
    {
      title: 'Financial Reports',
      description: 'View system-wide financial analytics',
      icon: <Analytics />,
      href: '/admin/financial',
      color: 'success' as const,
    },
    {
      title: 'System Reports',
      description: 'Generate comprehensive system reports',
      icon: <TrendingUp />,
      href: '/admin/reports',
      color: 'info' as const,
    },
  ];

  return (
    <EmployeeLayout>
      <Box>
        {/* Header */}
        <Box sx={{ mb: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Dashboard sx={{ mr: 2, fontSize: 32, color: 'primary.main' }} />
            <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
              Employee Dashboard
            </Typography>
          </Box>
          <Typography variant="body1" color="text.secondary">
            Welcome back, {userProfile?.name || 'Employee'}. Here's your system overview.
          </Typography>
        </Box>

        {/* System Metrics Cards */}
        <SystemMetricsCards autoRefresh={true} refreshInterval={30000} />

        {/* Quick Actions */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" sx={{ mb: 3, fontWeight: 'bold' }}>
            Quick Actions
          </Typography>
          <Grid container spacing={3}>
            {quickActions.map((action) => (
              <Grid item xs={12} sm={6} md={3} key={action.title}>
                <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Box sx={{ color: `${action.color}.main`, mr: 1 }}>
                        {action.icon}
                      </Box>
                      <Typography variant="h6" component="div">
                        {action.title}
                      </Typography>
                    </Box>
                    <Typography variant="body2" color="text.secondary">
                      {action.description}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button 
                      size="small" 
                      color={action.color}
                      href={action.href}
                      sx={{ ml: 1 }}
                    >
                      Access
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>


      </Box>
    </EmployeeLayout>
  );
};

export default EmployeeDashboard;